import axios from 'axios';
import { TurnoModel } from '../../pages/catalogos/turnos/models/TurnoModel';

const API_URL = process.env.REACT_APP_API;

export async function obtenerTurnosService() {
  try {
    const response = await axios.get(`${API_URL}turno`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function obtenerTurnoPorIdService(id: number) {
  try {
    const response = await axios.get(`${API_URL}turno/${id}`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function guardarTurnoService(turno: TurnoModel) {
  try {
    const { id, nombre } = turno;
    if (id) {
      const response = await axios.put(`${API_URL}turno/${id}`, { nombre });
      return response;
    } else {
      const response = await axios.post(`${API_URL}turno`, { nombre });
      return response;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function eliminarTurnoService(id: number) {
  try {
    const response = await axios.delete(`${API_URL}turno/${id}`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
